module.exports = __webpack_public_path__ + "img/undertakingCases7.b6ba306e.jpg";